/**
 * Determine if status Failed.
 * @param {string} status The children prop of a component.
 * @returns {Boolean}
 */
export const statusFailed = (status) => Array.isArray(status.match(/failed$/));

/**
 * Determine if status final.
 * @param {string} status The children prop of a component.
 * @returns {Boolean}
 */
export const statusFinal = (status) =>
  Array.isArray(status.match(/(completed|failed)$/));
